import("../../../css/bem/_quick-wishlist.scss");
import { addToWishlist, removeFromWishlist, getCurrentWishlistData, getWishlistCount } from "./wishlist-services";
import { wishlistGetProductId } from "../associated-product/associated-product";
import { displayToast } from "../toastify/toastify";
import { refreshQuickWishlistPanel } from "../quick-wishlist/quick-wishlist-ui";
import { ReferenceElement } from "tippy.js";
import { gtag } from "../utility-functions/utility-functions";

const wishlistSelector = '.js-wishlist-icon';
const wishlistHeaderCount = '.js-wishlist-count';
const toggleActiveClass = (elm: HTMLElement) => elm.classList.toggle('is-active');
const getActiveClass = (elm: HTMLElement) => elm.classList.contains('is-active');
const modifyContent = (elm: HTMLElement, html) => (elm.innerHTML = html);
const setDataAttribute = (elm: HTMLElement, toggle: boolean) => {
  const dataState = getDataState(elm, toggle);
  if (dataState) elm.setAttribute('data-tippy-content', dataState);
};
const getDataState = (elm: HTMLElement, toggle: boolean) =>
  elm.getAttribute(toggle ? 'data-tippy-deactive' : 'data-tippy-active');

export const toggleIconState = (id) => {
  (document.querySelectorAll(wishlistSelector) as NodeListOf<HTMLElement>).forEach((icon) => {
    if (Number(wishlistGetProductId(icon)) === id) {
      toggleActiveClass(icon);
      handleTippy(icon);
    }
  });
};

const handleTippy = (icon: HTMLElement) => {
  if (icon.hasAttribute('data-tippy-content')) {
    const instance = (<ReferenceElement>icon)._tippy;
    setDataAttribute(icon, getActiveClass(icon));
    instance?.setContent(getDataState(icon, getActiveClass(icon)));
  }
};

const handleWishlistClick = async (elm: HTMLElement, productid: Number) => {
	var isRemove = elm.classList.contains("is-active"),
		request = isRemove ? await removeFromWishlist(productid) : await addToWishlist(productid),
		message = request.success ? (isRemove ? "Removed from wishlist" : "Added to wishlist") : "An Unexpected Error Occurred";

	displayToast(message, {
		className: "toastify-center rounded px-lg-5 " + (request.success ? "swatch-dark" : "swatch-danger"),
		duration: 1500,
	});

	const isPlp = document.querySelector('body').classList.contains('listing');
	const isPdp = document.querySelector('body').classList.contains('productPage');
	if (!isRemove) {
		const product = elm.closest<HTMLElement>('.associated-product');
		const productName = product?.querySelector<HTMLElement>('.associated-product__title')?.innerText || '';
		const id = product?.dataset.id || '';
		const priceEl = product?.querySelector<HTMLElement>('.pricing-block__price')
			|| document.querySelector<HTMLElement>('.pricing-block__price');
		const value = parseFloat((priceEl?.querySelector('span')?.innerText || '').replace(/[^0-9.]/g, '')) || 0;
		const currency = priceEl?.dataset.currency || 'GBP';

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'add to wishlist',
			product_id: productid,
			value,
			currency,
			items: [{
				item_name: productName,
				item_id: id,
				product_id: productid,
				price: value,
				quantity: 1
			}]
		});

		if (isPlp) {
			gtag('event', 'plp_save_link_click', {
				current_url: window.location.pathname,
				currency,
				value,
				item: productName,
				id,
				product_id: productid
			});
		}

		if (isPdp) {
			gtag('event', 'pdp_save_link_click', {
				current_url: window.location.pathname,
				product_id: productid,
				value,
				currency
			});
		}
	}

	wishlistPageCheck(isRemove);

	if (request.success) {
		updateWishlistCount({ cacheBuster: true });
		toggleIconState(productid);
		refreshQuickWishlistPanel();
	}
};

export const updateWishlistCount = async ({ count = -1, cacheBuster = false }) => {
	if (count < 0) count = await getWishlistCount({ cacheBuster });
	(document.querySelectorAll(wishlistHeaderCount) as NodeListOf<HTMLElement>).forEach((item) => {
		modifyContent(item, count ?? 0);
	});

	const wishlistHeaderCountElements = document.querySelectorAll(wishlistHeaderCount) as NodeListOf<HTMLElement>;
	wishlistHeaderCountElements.forEach((item) => {
		if (count <= 0 == false) {
			item.classList.remove("d-none");
		} else {
			item.classList.add("d-none");
		}
	});
};

export const setUpWishlistBtnEventListeners = (context: HTMLElement | Document = document, wishlistFetchOptions?: { cacheBuster: boolean }) => {
	const allElms = context.querySelectorAll<HTMLElement>(wishlistSelector);

	getCurrentWishlistData(wishlistFetchOptions).then((wishlist) => {
		const wishlistIds = wishlist && wishlist[0] ? (wishlist as Array<any>).map((item) => item.productId) : [];

		allElms.forEach((elm) => {
			let productid = Number(wishlistGetProductId(elm));

			if (wishlistIds.includes(productid)) {
				elm.classList.add('is-active');
				setDataAttribute(elm, getActiveClass(elm));
			}

			elm.addEventListener("click", () => {
				const swatchId = elm.closest('.associated-product__inner')?.querySelector<HTMLElement>('.associated-product-colour--active')?.dataset.productid;
				if (swatchId && swatchId != "0") productid = +swatchId;
				if (swatchId == "0") productid = +elm.closest<HTMLElement>('.associated-product')?.dataset.pid;
				handleWishlistClick(elm, productid);
			});
		});
	});
};

const wishlistPageCheck = (isRemove: boolean) => {
	const isWishlist = document.querySelector("body.wishlist");
	const isAccount = document.querySelector("body.accountPage");
	if (isRemove && isWishlist)
		setTimeout(() => {
			location.reload();
		}, 100);
	if (isRemove && isAccount) {
		let url;
		if (window.location.href.indexOf("#wishlist") < 1) url = window.location.href += "#wishlist";
		setTimeout(() => {
			location.reload();
		}, 100);
	}
};

export const handleSwatchChange = (element: HTMLElement, swatch?: HTMLElement) => {
  setTimeout(() => {
    getCurrentWishlistData().then((data) => {
      let active = false;
      const swatchId = swatch && +swatch.dataset.productid ? +swatch.dataset.productid : +element?.dataset.pid;
      data.forEach((product) => {
        if (product.productId == swatchId) active = true;
      });
      const icon = element.querySelector<HTMLElement>('.js-wishlist-icon');
      if (icon) {
        icon.classList.toggle('is-active', active);
        handleTippy(icon);
      }
    });
  }, 500);
};